import { HEIGHT_CONSTANT } from '@utils/constants'
import { StylesClasses, commonStyles, createStyles } from '@utils/styles'

const styles = createStyles({
  // Drawer styles for mobile
  drawer: {
    '& .MuiDrawer-paper': {
      width: '95dvw',
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
  },
  stickyHeader: {
    ...commonStyles.flexSpace(),
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: 'white',
    padding: '1rem',
    borderBottom: '1px solid',
    borderColor: 'border.light',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  scrollableContent: {
    flex: 1,
    overflow: 'auto',
    padding: '1rem',
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#ccc',
      borderRadius: '2px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#aaa',
    },
  },

  // Main layout
  mainWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    position: 'relative',
  },
  headingWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '20px',
    flexWrap: 'wrap',
  },

  // Content area
  contentArea: {
    flex: 1,
    gap: 2,
    display: 'flex',
    flexDirection: 'column',
  },
  searchHeader: {
    ...commonStyles.flexSpace(),
  },
  contentWrapper: {
    flex: 1,
  },
  cardsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginTop: '-16px',
  },
  pageBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '10px',
  },

  // Aside / Sidebar
  asideContainer: {
    width: {
      md: '318px',
      sm: '100%',
      xs: '100%',
    },
    display: {
      xs: 'none',
      sm: 'block',
    },
  },
  asideStickyWrapper: {
    position: 'sticky',
    padding: '1rem 0rem',
    top: `${HEIGHT_CONSTANT.HEADER_HEIGHT - 40}px`,
    width: {
      md: '100%',
      sm: '100%',
    },
  },

  // Filter section
  filterWrapper: {
    backgroundColor: {
      xs: 'unset',
      sm: 'background.paper',
    },
    borderRadius: {
      xs: 'none',
      sm: '16px',
    },
    padding: {
      xs: 'none',
      sm: '8px 12px',
    },
    maxWidth: {
      xs: '100%',
      sm: '100%',
      md: '318px',
    },
    minWidth: {
      xs: '100%',
      sm: '100%',
      md: '318px',
    },
    gap: '24px',
    maxHeight: 'fit-content',
    border: {
      xs: 'none',
      sm: '1px solid',
    },
    borderColor: {
      xs: 'unset',
      sm: 'border.dark',
    },
    overflow: 'hidden',
    boxShadow: {
      xs: 'none',
      sm: 2,
    },
  },
  accordionWrapper: {
    padding: '3px',
    display: {
      xs: 'none',
      sm: 'block',
    },
  },
  accordionDrawer: {
    display: {
      xs: 'none',
      sm: 'flex',
    },
    flexWrap: 'wrap',
    gap: '14px',
    marginTop: '16px',
    maxHeight: '390px',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    padding: '4px 0px 0px 1px',
  },

  // Card styles
  milestoneCardContent: {
    marginBlock: '12px',
    gap: {
      xs: '16px',
      md: '24px',
    },
    border: 'none',
  },
  mileStoneTitle: {
    fontSize: '1.5rem',
    lineHeight: '2rem',
  },
  mileStoneDescription: {
    fontSize: '1.02rem',
    lineHeight: '1.5rem',
    color: 'text.secondary',
    marginTop: '-0.5rem',
  },
  leftView: {
    minWidth: {
      xs: '100%',
      md: 'unset',
    },
    justifyContent: 'space-between',
  },
  image: {
    maxWidth: {
      xs: '100%',
      md: '240px',
    },
  },
  blogData: {
    justifyContent: 'space-between !important',
  },
  categoryNotFoundWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    py: 3,
    px: 2,
    minHeight: '100%',
  },
  ctaWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  applyFilterButton: {
    borderRadius: '12px',
    px: 4,
    py: 1.2,
  },
})

export type StylesClassNames = StylesClasses<typeof styles>
export default styles
